import React, { Suspense, lazy } from "react";
import { Routes, Route, matchPath, useLocation, useNavigate } from "react-router-dom";
import Header from "../header/header";
import Footer from "../footer/footer";
import SabraahAiFloater from "../componants/sabraahAi/SabraahAiFloater";
import NotFound from "../componants/NotFound";
import PrivateRoute from "./PrivateRoute";
import AuthFormSkeleton from "../componants/skeletons/AuthFormSkeleton";
import FormCardSkeleton from "../componants/skeletons/FormCardSkeleton";
import FlightSearchSkeleton from "../componants/skeletons/FlightSearchSkeleton";
import FlightListSkeleton from "../componants/skeletons/FlightListSkeleton";
import accountSetupSteps from "./accountSetupSteps";
import RoundFlightList from "../pages/flight/roundTripSearch/roundFlightList";
import HotelMain from "../pages/hotel/hotel";
import HotelDetail from "../pages/hotel/hotel-details/hotelDetail";
import HotelBookingDetail from "../pages/hotel/hotelAllBookingDetails/hotelBookingDetail";
import HotelPayment from "../pages/hotel/hotelPayment";
import HotelBookingConfirm from "../pages/hotel/hotelBookingConfirm";
import VenueMain from "../pages/venue/venue";
import HolidaysMain from "../pages/holidays/holidays";
import VenueDetail from "../pages/venue/venue-details/venueDetail";
import VenueBookingDetail from "../pages/venue/venueAllBookingDetails/venueBookingDetail";
import VenuePayment from "../pages/venue/venuePayment";
import VenueBookingConfirm from "../pages/venue/venueBookingConfirm";
import VenueProposalDetail from "../pages/venue/venueProposalDetail/venueProposalDetail";
import VenueCompareProposals from "../pages/venue/venueCompareProposals/venueCompareProposals";
import VenueSuggestedVenues from "../pages/venue/venueSuggestedVenues/venueSuggestedVenues";
import VenueNegotiation from "../pages/venue/venueNegotiation/venueNegotiation";
import VenueConfirmBooking from "../pages/venue/venueConfirmBooking/venueConfirmBooking";
import VenueBookingSuccess from "../pages/venue/venueBookingSuccess/venueBookingSuccess";
import MainProfile from "../pages/profile/mainProfile";
import TripDoc from "../pages/profile/mytrip/tripDoc";
import AddMoneyWallet from "../pages/profile/mywallet/addMoneyWallet";
import OfferCashback from "../pages/profile/mywallet/offerCashback";
import MyTransaction from "../pages/profile/mywallet/myTransaction";
import CruiseMain from "../pages/cruise/cruise";
import CruiseDetail from "../pages/cruise/cruise-details/cruiseDetail";
import CruiseBookingConfirm from "../pages/cruise/CruiseBookingConfirm";
import CarRentalMain from "../pages/carRental/carRental";
import CarDetail from "../pages/carRental/car-details/carDetail";
import CarBookingDetail from "../pages/carRental/carAllBookingDetails/carBookingDetail";
import CarBookingConfirm from "../pages/carRental/carBookingConfirm";
import Wishlist from "../pages/wishlist/wishlist";
import CreateWishlist from "../pages/wishlist/createWishlist";
import AddWishlistItem from "../pages/wishlist/addWishlistItem";
import SelectItems from "../pages/wishlist/selectItems";
import WishlishtSetting from "../pages/wishlist/wishlishtSetting";
import WishlistPersonal from "../pages/wishlist/wishlistPersonal/wishlistPersonal";
import WishlistDetail from "../pages/wishlist/wishlistDetail";
import WishlistJoin from "../pages/wishlist/wishlistJoin";
import SplitwiseJoin from "../pages/profile/groups/splitwiseJoin";
import EventBookingDetail from "../pages/eventHandling/eventBookingDetail/eventBookingDetail";
import EventPayment from "../pages/eventHandling/eventPayment";
import EventBookingConfirm from "../pages/eventHandling/eventBookingConfirm";
import EventBookingHome from "../pages/eventHandling/eventBookingHome";
import EventDetail from "../pages/eventHandling/eventDetail/eventDetail";
import EventListPage from "../pages/eventHandling/eventList/eventListPage";
import BusBooking from "../pages/bus/bus";
import FindBus from "../pages/bus/busList/findbus";
import BusSeatSelection from "../pages/bus/busList/busSeatTab/busSeatSelection";
import BusBoardingPage from "../pages/bus/busList/busSeatTab/busBoardingPage";
import BusPhotosPage from "../pages/bus/busList/busSeatTab/busPhotosPage";
import BusRatingPage from "../pages/bus/busList/busSeatTab/busRatingPage";
import BusCancelPage from "../pages/bus/busList/busSeatTab/busCancelPage";
import BusBookingDetail from "../pages/bus/busBookingDetails/busBookingDetail";
import BusPayment from "../pages/bus/busPayment";
import BusBookingConfirm from "../pages/bus/busBookingConfirm";
import Train from "../pages/train/train";
import TrainList from "../pages/train/trainList";
import FlightTrack from "../pages/flightTracking/flightTrack";
const FindHotel = lazy(() => import("../pages/hotel/hotelListing/findHotel"));
const FindVenue = lazy(() => import("../pages/venue/venueListing/findVenue"));
const FindHolidays = lazy(() => import("../pages/holidays/holidaysListing/findHolidays"));
const HolidayDetail = lazy(() => import("../pages/holidays/holidayDetail/holidayDetail"));
const HolidayCustomize = lazy(() => import("../pages/holidays/holidayCustomize/holidayCustomize"));
const HolidayCheckout = lazy(() => import("../pages/holidays/holidayCheckout/holidayCheckout"));
const HolidayPayment = lazy(() => import("../pages/holidays/holidayPayment/holidayPayment"));
const HolidayBookingConfirm = lazy(() => import("../pages/holidays/holidayBookingConfirm/holidayBookingConfirm"));
const FindCruise = lazy(() => import("../pages/cruise/cruiseListing/findCruise"));
const CruiseBookingDetail = lazy(() => import("../pages/cruise/cruiseAllBookingDetails/cruiseBookingDetail"));
const FindCar = lazy(() => import("../pages/carRental/carListing/findCar"));
const CarPayment = lazy(() => import("../pages/carRental/carPayment"));
const BlogListing = lazy(() => import("../pages/blog/blogListing"));
const AboutUs = lazy(() => import("../pages/aboutUs/about-us"));
const BlogDetail = lazy(() => import("../pages/blog/blogDetail"));

// ── Onboarding ───────────────────────────────────────────────────────────────
const Login = lazy(() => import("../pages/onboarding/Login"));
const ForgotPassword = lazy(() => import("../pages/onboarding/ForgotPassword"));
const OTP = lazy(() => import("../pages/onboarding/OTP"));
const NewPassword = lazy(() => import("../pages/onboarding/NewPassword"));

// Reused as-is from the (private) profile section — same component, same
// API-fetched content, just given a public entry point so a signed-out
// visitor can read them from the Login screen without hitting PrivateRoute.
const PrivacyPolicyContent = lazy(() => import("../pages/profile/privacySecurity/privacyPolicy"));
const TermsServiceContent = lazy(() => import("../pages/profile/privacySecurity/termsService"));
const StandalonePrivacyPolicy = () => {
  const navigate = useNavigate();
  return <PrivacyPolicyContent onBack={() => navigate("/")} />;
};
const StandaloneTermsService = () => {
  const navigate = useNavigate();
  return <TermsServiceContent onBack={() => navigate("/")} />;
};

// ── Account setup (post-OTP wizard) ───────────────────────────────────────────
const CreateAccount = lazy(() => import("../pages/onboarding/CreateAccount"));
const PersonalInformation = lazy(() => import("../pages/onboarding/PersonalInformation"));
const LocationPreferences = lazy(() => import("../pages/onboarding/LocationPreferences"));
const TravelInterests = lazy(() => import("../pages/onboarding/TravelInterests"));
const TravelPreferences = lazy(() => import("../pages/onboarding/TravelPreferences"));

// ── Flight ───────────────────────────────────────────────────────────────────
const Flight = lazy(() => import("../pages/flight/flight"));
const FlightList = lazy(() => import("../pages/flight/findFlight"));
const FlightBookingDetail = lazy(() => import("../pages/flight/flightAllBookingDetails/flightBookingDetail"));
const FlightDetails = lazy(() => import("../pages/flight/flightDetails/flightDetails"));
const FlightSeats = lazy(() => import("../pages/flight/flightSeats/flightSeats"));
const Payment = lazy(() => import("../pages/flight/payment"));
const BookingConfirm = lazy(() => import("../pages/flight/bookingConfirm"));

// ─────────────────────────────────────────────────────────────────────────────
// Route configs
// ─────────────────────────────────────────────────────────────────────────────

const publicRoutes = [
  { path: "/", element: <Login />, skeleton: <AuthFormSkeleton /> },
  { path: "/forgot-password", element: <ForgotPassword />, skeleton: <AuthFormSkeleton /> },
  { path: "/otp", element: <OTP />, skeleton: <AuthFormSkeleton /> },
  { path: "/set-password", element: <NewPassword />, skeleton: <AuthFormSkeleton /> },
  { path: "/privacy-policy", element: <StandalonePrivacyPolicy />, skeleton: <FormCardSkeleton /> },
  { path: "/terms-conditions", element: <StandaloneTermsService />, skeleton: <FormCardSkeleton /> },
];

const siteRoutes = [
  { path: "/home", element: <Flight />, skeleton: <FlightSearchSkeleton />, private: true },
  { path: "/flights", element: <FlightList />, skeleton: <FlightListSkeleton />, private: true },
  { path: "/flights-round", element: <RoundFlightList />, skeleton: <FlightListSkeleton />, private: true },
  { path: "/flight-booking-detail", element: <FlightBookingDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/flight-details", element: <FlightDetails />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/flight-seats", element: <FlightSeats />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/payment", element: <Payment />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/booking-confirm", element: <BookingConfirm />, skeleton: <FormCardSkeleton />, private: true },

  { path: "/hotel", element: <HotelMain />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/hotel-list", element: <FindHotel />, skeleton: <FlightListSkeleton />, private: true },
  { path: "/hotel-detail/:id", element: <HotelDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/hotel-booking-detail", element: <HotelBookingDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/hotel-payment", element: <HotelPayment />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/hotel-booking-confirm", element: <HotelBookingConfirm />, skeleton: <FormCardSkeleton />, private: true },

  { path: "/venue", element: <VenueMain />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/holidays", element: <HolidaysMain />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/venue-list", element: <FindVenue />, skeleton: <FlightListSkeleton />, private: true },
  { path: "/holidays-list", element: <FindHolidays />, skeleton: <FlightListSkeleton />, private: true },
  { path: "/holidays-detail/:id", element: <HolidayDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/holidays-customize/:id", element: <HolidayCustomize />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/holidays-checkout/:id", element: <HolidayCheckout />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/holidays-payment/:id", element: <HolidayPayment />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/holidays-booking-confirm/:id", element: <HolidayBookingConfirm />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/venue-detail/:id", element: <VenueDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/venue-booking-detail/:venueId", element: <VenueBookingDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/venue-booking-confirm", element: <VenueBookingConfirm />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/venue-proposal-detail/:id", element: <VenueProposalDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/venue-compare", element: <VenueCompareProposals />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/venue-suggested-venues/:proposalId", element: <VenueSuggestedVenues />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/venue-negotiate/:id", element: <VenueNegotiation />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/venue-confirm-booking/:id", element: <VenueConfirmBooking />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/venue-payment/:id", element: <VenuePayment />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/venue-booking-success/:id", element: <VenueBookingSuccess />, skeleton: <FormCardSkeleton />, private: true },

  { path: "/profile", element: <MainProfile />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/trip-doc", element: <TripDoc />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/add-money", element: <AddMoneyWallet />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/offer-cashback", element: <OfferCashback />, skeleton: <FormCardSkeleton />, private: true },
{ path: "/my-transaction", element: <MyTransaction />, skeleton: <FormCardSkeleton />, private: true },

  { path: "/cruise", element: <CruiseMain />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/cruise-list", element: <FindCruise />, skeleton: <FlightListSkeleton />, private: true },
  { path: "/cruise-detail", element: <CruiseDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/cruise-booking-detail", element: <CruiseBookingDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/cruise-booking-confirm", element: <CruiseBookingConfirm />, skeleton: <FormCardSkeleton />, private: true },

  { path: "/car-rental", element: <CarRentalMain />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/car-list", element: <FindCar />, skeleton: <FlightListSkeleton />, private: true },
  { path: "/car-detail", element: <CarDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/car-booking-detail", element: <CarBookingDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/car-payment", element: <CarPayment />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/car-booking-confirm", element: <CarBookingConfirm />, skeleton: <FormCardSkeleton />, private: true },

  { path: "/blog-listing", element: <BlogListing />, skeleton: <FlightListSkeleton />, private: true },
  { path: "/blog-detail", element: <BlogDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/about-us", element: <AboutUs />, skeleton: <FormCardSkeleton />, private: true },

  { path: "/wishlist", element: <Wishlist />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/create-wishlist", element: <CreateWishlist />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/add-wishlist-item", element: <AddWishlistItem />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/select-items", element: <SelectItems />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/wishlist-setting", element: <WishlishtSetting />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/wishlist-personal", element: <WishlistPersonal />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/wishlist-detail", element: <WishlistDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/wishlist/join/:token", element: <WishlistJoin />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/splitwise/join/:token", element: <SplitwiseJoin />, skeleton: <FormCardSkeleton />, private: true },


  { path: "/event-booking", element: <EventBookingHome />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/event-list", element: <EventListPage />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/event-detail/:id", element: <EventDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/event-booking-detail", element: <EventBookingDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/event-payment", element: <EventPayment />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/event-booking-confirm", element: <EventBookingConfirm />, skeleton: <FormCardSkeleton />, private: true },

  { path: "/bus", element: <BusBooking />, skeleton: <FlightSearchSkeleton />, private: true },
  { path: "/bus-list", element: <FindBus />, skeleton: <FlightSearchSkeleton />, private: true },
  { path: "/bus-seat-selection", element: <BusSeatSelection />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/bus-boarding-points", element: <BusBoardingPage />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/bus-photos-amenities", element: <BusPhotosPage />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/bus-ratings-reviews", element: <BusRatingPage />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/bus-cancellation", element: <BusCancelPage />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/bus-booking-detail", element: <BusBookingDetail />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/bus-payment", element: <BusPayment />, skeleton: <FormCardSkeleton />, private: true },
  { path: "/bus-booking-confirm", element: <BusBookingConfirm />, skeleton: <FormCardSkeleton />, private: true },



  { path: "/train", element: <Train />, skeleton: <FlightSearchSkeleton />, private: true },
  { path: "/train-list", element: <TrainList />, skeleton: <FlightSearchSkeleton />, private: true },

  { path: "/flight-tracking", element: <FlightTrack />, skeleton: <FlightSearchSkeleton />, private: true },
];

const accountSetupPages = [
  CreateAccount,
  PersonalInformation,
  LocationPreferences,
  TravelInterests,
  TravelPreferences,
];

const accountSetupRoutes = accountSetupSteps.map((step, index) => ({
  path: step.path,
  element: React.createElement(accountSetupPages[index]),
  skeleton: <FormCardSkeleton />,
}));

// ─────────────────────────────────────────────────────────────────────────────

// Final payment/checkout step of each vertical — its own sticky "Pay Now"
// action bar sits at the bottom of the page, so the site footer is skipped
// here specifically (every other page gets it).
const NO_FOOTER_PATHS = new Set([
  "/booking-confirm",
  "/hotel-booking-confirm",
  "/venue-confirm-booking/:id",
  "/cruise-booking-confirm",
  "/car-booking-confirm",
  "/event-booking-confirm",
  "/bus-booking-confirm",
]);

// Suspense is inside LayoutWrapper so the header stays visible during page load
const LayoutWrapper = ({ children, skeleton, path }) => (
  <>
    <Header />
    <Suspense fallback={skeleton}>{children}</Suspense>
    {NO_FOOTER_PATHS.has(path) ? null : <Footer />}
  </>
);

const AppRoutes = () => {
  const { pathname } = useLocation()
  const showAi = siteRoutes.some(({ path }) => matchPath({ path, end: true }, pathname))
  return (
  <>
  <Routes>
    {siteRoutes.map(({ path, element, skeleton, private: isPrivate }) => (
      <Route
        key={path}
        path={path}
        element={
          <LayoutWrapper skeleton={skeleton} path={path}>
            {isPrivate ? <PrivateRoute>{element}</PrivateRoute> : element}
          </LayoutWrapper>
        }
      />
    ))}
    {accountSetupRoutes.map(({ path, element, skeleton }) => (
      <Route
        key={path}
        path={path}
        element={<LayoutWrapper skeleton={skeleton} path={path}>{element}</LayoutWrapper>}
      />
    ))}
    {publicRoutes.map(({ path, element, skeleton }) => (
      <Route
        key={path}
        path={path}
        element={
          <Suspense fallback={skeleton}>{element}</Suspense>
        }
      />
    ))}
    <Route path="*" element={<NotFound />} />
  </Routes>
  {showAi ? <SabraahAiFloater /> : null}
  </>
  )
}

export default AppRoutes;
